import * as THREE from 'three';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { prepareNum, unitTransform } from '@services/helper.service';

import Input from '@components/Input';
import { defaultUnits } from '@config';
import './styles.scss';
import { APP_TEXTS } from '@texts';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../texts/tooltips';

class PositionsTable extends Component {

  static propTypes = {
    isDisabled: PropTypes.bool,
    //invert: PropTypes.bool,
    onUpdate: PropTypes.func,
    positions: PropTypes.array.isRequired, // eslint-disable-line,
    maxLength: PropTypes.number
  };

  state = {
    positions: this.props.positions
  };

  // componentWillReceiveProps(props) {
  //   if (props.positions) {
  //     this.setState({
  //       positions: props.positions
  //     });
  //   }
  // }

  render() {
    return (
      <div>
      <React.Fragment>
        {!this.props.isDisabled && (
            <div>
              <Tooltip content={APP_TOOLTIPS.TOOLTIP_ADD.Content}>
                <button
                  className="btn btn-light"
                  disabled={this.props.isDisabled}
                  onClick={() => {
                    if (!this.props.maxLength || this.props.positions.length < this.props.maxLength)
                      this.addScrew();
                  }}
                >
                  + {APP_TEXTS.POSITION_TABLE_ADD.Content}
                </button>
                </Tooltip>
            </div>
        )}

            <table className="table">
            <thead>
              <tr>
                <th>#</th>
                <th>{APP_TEXTS.LABEL_POSITIONS_TABLE_X.Content}</th>
                <th>{APP_TEXTS.LABEL_POSITIONS_TABLE_Y.Content}</th>
                {!this.props.isDisabled && <th />}
              </tr>
            </thead>
            <tbody>
              {this.props.positions.map((item, index) => (
                <tr key={JSON.stringify(item) + index.toString()}>
                  <td>{index + 1}</td>
                  <td>
                    <Input
                      id={'y-input' + index}
                      type="number"
                      disabled={this.props.isDisabled}
                      value={
                        unitTransform(prepareNum(item.y))
                          .from(defaultUnits.DISTANCE)
                          .to(this.props.unit) //* (this.props.invert ? -1 : 1)
                      }
                      onUpdate={value => {
                        this.updateScrewCustomPosition(
                          unitTransform(+value) // * (this.props.invert ? -1 : 1))
                            .from(this.props.unit)
                            .to(defaultUnits.DISTANCE),
                          index,
                          'y'
                        );
                      }}
                      tabIndex={index * 2 + 1}
                    />
                  </td>
                  <td>
                    <Input
                      id={'z-input' + index}
                      type="number"
                      disabled={this.props.isDisabled}
                      value={
                        unitTransform(prepareNum(item.z))
                          .from(defaultUnits.DISTANCE)
                          .to(this.props.unit) // * (this.props.invert ? -1 : 1)
                      }
                      onUpdate={value => {
                        this.updateScrewCustomPosition(
                          unitTransform(+value) // * (this.props.invert ? -1 : 1))
                            .from(this.props.unit)
                            .to(defaultUnits.DISTANCE),
                          index,
                          'z'
                        );
                      }}
                      tabIndex={index * 2 + 2}
                    />
                  </td>
                  {!this.props.isDisabled && (
                    <td>
                      <Tooltip content={APP_TOOLTIPS.TOOLTIP_REMOVE.Content}>
                      <button
                        className="btn btn-light"
                        disabled={this.props.isDisabled}
                        onClick={() => {
                          this.removeScrew(index);
                        }}
                        tabIndex={0} // disable tab
                      >
                        <span className="icon_remove" />
                      </button>
                      </Tooltip>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
      </React.Fragment>
      </div>
    );
  }

  addScrew = () => {
    this.props.onUpdate &&
      this.props.onUpdate({
        custom: {
          positions: [...this.props.positions, new THREE.Vector3(0, 0, 0)]
        }
      });
  };

  removeScrew = index => {
    const { positions } = this.props;

    positions.splice(index, 1);

    this.props.onUpdate &&
      this.props.onUpdate({
        custom: {
          positions: [...positions]
        }
      });
  };

  updateScrewCustomPosition = (value, index, axis) => {
    const { positions } = this.props;

    positions[index][axis] = +value;

    this.props.onUpdate &&
      this.props.onUpdate({
        custom: {
          positions
        }
      });
  };
  
}

const mapState = state => ({
  unit: state.main.units.distance
});

export default connect(mapState)(PositionsTable);



// WEBPACK FOOTER //
// ./src/components/PositionsTable/PositionsTable.js